module.exports = __webpack_public_path__ + "img/feature-06.ce253bc5.png";